if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        var loadingbar = document.querySelector(".loading-bar");
        var loadingbarinner = document.querySelector(".loading-bar-inner");
        loadingbar.classList.add("is-visible");
        loadingbarinner.style.transform="scaleX(0.4)";
        
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {

            loadingbarinner.style.transform="scaleX(1)"; 
            
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.productElement.classList.forEach((classApplied) => {
              if (classApplied.startsWith('color-') || classApplied === 'gradient')
                this.modalContent.classList.add(classApplied);
            });
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
            setTimeout(function(){
              loadingbar.classList.remove("is-visible");
              loadingbarinner.style.transform="scaleX(0)";  
            },1000);
            var _this = this;
            if($(this).find('.product__media-list.carousel-main').hasClass('flickity-enabled')){
                $(this).find('.product__media-list.carousel-main').flickity('destroy');
              }
             if(!$(this).find('.product__media-list.carousel-main').hasClass('flickity-enabled')){
        $.getScript('https://cdnjs.cloudflare.com/ajax/libs/flickity/2.2.2/flickity.pkgd.min.js', function () {
            var $cartcarousel = $('.cart-edit_main .product__media-list.carousel-main').flickity({
              contain: true,
              pageDots: true,
            });
          });
      }

         const option1 = opener.dataset.option1;
        const option2 = opener.dataset.option2;
        const option3 = opener.dataset.option3;

        if (option1) {
          console.log("s iuh kjhj hj");
          const radio1 = _this.modalContent.querySelector(`input.data_option1[value="${option1}"]`);
          if (radio1) {
            console.log("ssss ");
            radio1.checked = true;
            radio1.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        if (option2) {
          const radio2 = _this.modalContent.querySelector(`input.data_option2[value="${option2}"]`);
          if (radio2) {
            radio2.checked = true;
            radio2.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        if (option3) {
          const radio3 = _this.modalContent.querySelector(`input.data_option3[value="${option3}"]`);
          if (radio3) {
            radio3.checked = true;
            radio3.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
    
      
            setTimeout(function(){

        if (option1) {
          console.log("s iuh kjhj hj");
          const radio1 = _this.modalContent.querySelector(`input.data_option1[value="${option1}"]`);
          if (radio1) {
            console.log("ssss ");
            radio1.checked = true;
            radio1.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        if (option2) {
          const radio2 = _this.modalContent.querySelector(`input.data_option2[value="${option2}"]`);
          if (radio2) {
            radio2.checked = true;
            radio2.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        if (option3) {
          const radio3 = _this.modalContent.querySelector(`input.data_option3[value="${option3}"]`);
          if (radio3) {
            radio3.checked = true;
            radio3.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
    
            },1000);
        
          })
          .finally(() => {

            setTimeout(function(){
              loadingbar.classList.remove("is-visible");
              loadingbarinner.style.transform="scaleX(0)";
            },1000);
            
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
            
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
